"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({target}) {
        this.state = { actives: uiStore.get(`${ target }-active-filters`) || [] };
        GState.bind(this, ['tenant']);
        this.categories = [];
        const collector = function (arrayList) {
            arrayList.map(({categoryId, name, description, poster, subs}) => {
                this.categories.push({
                    categoryId,
                    name,
                    description,
                    poster
                });
                if (!!subs && !isEmpty(subs))
                    collector(Object.values(subs));
            });
        }.bind(this);
        Object.values(this.state.tenant.categories).map(({categoryId, name, description, poster, subs}) => {
            if (!!subs && !isEmpty(subs))
                collector(Object.values(subs));
            this.categories.push({
                categoryId,
                name,
                description,
                poster
            });
        });
    },
    onMount: function () {
        this.state.actives.length && this.emit('init', this.state.actives);
    },
    onAll: function () {
        this.emit('change', this.state.actives = []);
        uiStore.clear(`${ this.input.target }-active-filters`);
    },
    onFilter: function (name, status) {
        status ? !this.state.actives.includes(name) ? this.state.actives.push(name) : null : this.state.actives = this.state.actives.filter(each => {
            return each != name;
        });
        this.setStateDirty('actives');
        this.state.actives.length ? uiStore.set(`${ this.input.target }-active-filters`, this.state.actives) : uiStore.clear(`${ this.input.target }-active-filters`);
        this.emit('change', this.state.actives);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/CategoryFilters.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    FilterButton_template = require("./FilterButton.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    FilterButton_tag = marko_loadTag(FilterButton_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template);

function render(input, out, __component, component, state) {
  var data = input;

  Row_tag({
      class: "m-0 p-50",
      renderBody: function(out) {
        FilterButton_tag({
            label: "All",
            active: !state.actives.length
          }, out, __component, "1", [
          [
            "change",
            "onAll",
            false
          ]
        ]);

        marko_forOf(component.categories, function({ name }, index) {
          FilterButton_tag({
              label: name,
              active: state.actives.includes(name)
            }, out, __component, index, [
            [
              "change",
              "onFilter",
              false,
              [
                  name
                ]
            ]
          ]);
        });
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
